import * as React from "react";
const SvgFiRrBuilder = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-builder_svg__a)">
      <path
        fill="#062147"
        d="M9.893 17.047A8 8 0 0 0 9 17c-3.734 0-6.55 2.461-7.008 6.124a1 1 0 1 1-1.984-.248C.588 18.238 4.285 15 9 15q.568 0 1.107.059c.549.06.946.553.887 1.102-.06.55-.56.939-1.102.887zM1.5 7a1 1 0 0 1 1-1H3v-.5C3 2.468 5.467 0 8.5 0h1C12.533 0 15 2.468 15 5.5V6h.5a1 1 0 1 1 0 2H15c0 3.309-2.691 6-6 6s-6-2.691-6-6h-.5a1 1 0 0 1-1-1M13 8H5c0 2.206 1.794 4 4 4s4-1.794 4-4M5 6h8v-.5c0-1.758-1.308-3.204-3-3.449V4a1 1 0 1 1-2 0V2.051C6.308 2.296 5 3.742 5 5.5zm17.5 15h-3a1.5 1.5 0 0 0 0 3h3a1.5 1.5 0 0 0 0-3m-3-7h3a1.5 1.5 0 0 0 0-3h-3a1.5 1.5 0 0 0 0 3m-5 7h-3a1.5 1.5 0 1 0 0 3h3a1.5 1.5 0 0 0 0-3m2-5h-2a1.5 1.5 0 0 0 0 3h2a1.5 1.5 0 0 0 0-3m6 0h-1a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 0 0-3"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-builder_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBuilder;
